import injected from './injected';
import walletconnect from './walletconnect';

export { injected, walletconnect };
